module.exports = __webpack_public_path__ + "img/ticket_button@2x.9019c1e0.png";